import React from "react";
import Seo from "@/utils/seo";
import Head from "next/head";
import Banner from "@/components/ui/banner";
import Faq from "@/components/pages/faq/faq";
import { getJsonLd } from "@/utils/get-jsonld";
export default function FAQs() {
  const seo = {
    slug: "/faqs",
  };

  return (
    <>
      <Seo seo={seo} />
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(getJsonLd({ slug: "faqs" })),
          }}
        />
      </Head>
      <Banner
        image="/images/banner1.webp"
        heading="FAQs (Frequently Asked Questions)"
      />
      <Faq />
    </>
  );
}
